// extracted by mini-css-extract-plugin
export var container = "_8n-0";
export var icon = "_8n-1";
export var text = "_8n-2";